define('PartLookupSearcher.View', [
  // 'Backbone.View',
  'SCView',
  'Tracker',
  
  'PartLookupSearcher.Collection',
  'PartLookupSearcher.Item.View',
  'PartLookupSearcher.Utils',
  'partlookupsearcher.tpl',

  'Utils',
  'jQuery',
  'underscore'
], function (
  // BackboneView,
  SCViewModule,
  Tracker,
  
  PartLookupSearcherCollection,
  PartLookupSearcherItemView,
  PartLookupSearcherUtils,
  partlookupsearcher_tpl,

  Utils,
  jQuery,
  _

) {
  'use strict';

  var SCView = SCViewModule.SCView;
  var defaultOptions = {
    placeholderLabel: Utils.translate('Search models'),
    minLength: 3,
    maxLength: 10,
    limit: 10,
    sort: 'relevance:desc',
    labels: [],
    collection: PartLookupSearcherCollection,
    query: '',
    ajaxDone: false,
    showMenuOnClick: false,
    itemView: PartLookupSearcherItemView,
    highlight: true,
    template: partlookupsearcher_tpl,
    componentId: void 0,
    componentName: void 0,
    showSeeAll: true,
    highlightFirst: false,
    itemViewOptions: {},
    collectionOptions: {},
    // change the way items display name is returned
    getItemDisplayName: null,
    lastTypedQuery: ''  // ADD THIS LINE
  };

  function PartLookupSearcherView (options) {
    SCView.call(this, options);

    // this.application = options.application;
    this.options = _.defaults(options || {}, defaultOptions);

    this.collection = new this.options.collection(
      [],
      this.options.collectionOptions
    );
    
    this.template = this.options.template;

    this.options.application.getLayout().once('afterAppendView', this.configureTypeahead, this);

    this.options.application.getLayout().once('afterAppendView', this.configureTypeaheadTemp, this);
    // this.on('afterViewRender', this.configureTypeahead, this); ==> commented out before release
  }

  PartLookupSearcherView.prototype = Object.create(SCView.prototype);

  _.extend(PartLookupSearcherView.prototype, {

    constructor: PartLookupSearcherView,

    template: function () {},

    getEvents: function() {
      return {
        'keyup [data-type="model-part-search-input"]': 'onKeyUp',
        'keydown [data-type="model-part-search-input"]': 'onKeyDown',
      }
    },

    getTypeAheadConfiguration: function () {
      var self = this;

      return {
        limit: self.options && self.options.limit ? self.options.limit + 1 : '',
        source: _.debounce(_.bind(self.loadSuggestionItemsSource, self), 500),
        displayKey: _.bind(self.getSelectedItemDisplayText, self),
        templates: {
          suggestion: _.bind(self.getSuggestionItemTemplate, self),
        },
        async: true,
      };
    },

    configureTypeaheadTemp: function() {
      var self = this;
      self.$searchElement = self.$('[data-type="model-part-search-input"]');
    },

    configureTypeahead: function () {

      var self = this;
      var typeaheadOptions = {
        highlight: this.options.highlight,
        minLength: this.options.minLength,
      };

      self.$searchElement = self.$('[data-type="model-part-search-input"]');
      debugger;
      // after the layout has be rendered, we initialize the plugin
      if (SC.ENVIRONMENT.jsEnvironment !== 'server') {
        self.$searchElement
          .typeahead(typeaheadOptions, this.getTypeAheadConfiguration())
          .on('typeahead:selected', _.bind(self.onItemSelected, self));

        self.$searchElement.on('focus', _.bind(self.selectFirstIfRequire, self));

        // TYPE AHEAD HACKS
        var drop = self.$searchElement.data('ttTypeahead').menu;
        drop.$node.off('click.tt', '.tt-suggestion').on(
          'click.tt',
          '.tt-suggestion',
          _.bind(function ($e) {
            $e.preventDefault();
            $e.stopPropagation();
            drop.trigger('suggestionClicked', jQuery($e.currentTarget));
          }, drop)
        );

        // Display menu when selected the input hack
        if (self.options.showMenuOnClick) {
          self.$searchElement.focus(function () {
            var ev = jQuery.Event('keydown');

            ev.keyCode = ev.which = 40;
            jQuery(this).trigger(ev);
            return true;
          });
        }
      }
    },

    getCurrentQuery: function getCurrentQuery() {
      return String(this.$searchElement.val()).trim();
    },

    cleanSearch: function cleanSearch(stop_triggering_event) {
      this.$searchElement.data('ttTypeahead') &&
        this.$searchElement.data('ttTypeahead').close();

      this.$searchElement.typeahead('val', '');

      this.options.query = '';
      this.options.selectedItem = null;

      if (!stop_triggering_event) {
        this.trigger('itemSelected', {
          selectedItem: null,
          collection: this.collection.models,
          currentQuery: this.options.query,
        });
      }
    },

    onItemSelected: function onItemSelected(e, item_id) {
      
      this.options.selectedItem = this.collection.get(item_id);
      //var searchValue = (this.options?.query || this.$('.twitter-typeahead').find('pre').text());
      var searchValue = (
          this.options.lastTypedQuery ||
          this.$('.twitter-typeahead').find('pre').text() ||
          ''
      ).trim();
      var itemFields = this.options.selectedItem?.attributes;
      searchValue = searchValue.trim();
      //debugger;
      console.log({
        val: this.$searchElement.val(),
        typeaheadVal: this.$searchElement.typeahead('val'),
        optionsQuery: this.options.query,
        ttInput: this.$searchElement.siblings('.tt-input').val(),
        ttHint: this.$searchElement.siblings('.tt-hint').val(),
      });
      //var path = this.options.selectedItem.get('custitem_sep_parent_model_number');
      // Find which model number field matches what the user typed
      var path = '';
      var matchedField = 'custitem_sep_parent_model_number'; // default field
      for (var key in itemFields){
        if(key == 'custitem_sep_parent_model_number' || key == 'custitem_sep_parent_model_number2') {
          //debugger;
          if (!!searchValue && itemFields[key]?.includes(searchValue)) {
            //path = itemFields[key];
            path = itemFields[key];
            matchedField = key;
          }
        }
      }
      //debugger
      /*if(!path){
        path = this.options.selectedItem.get('custitem_sep_parent_model_number');
      }*/
      // Fallback to primary field if no match found
      if (!path) {
        path = this.options.selectedItem.get('custitem_sep_parent_model_number');
      }
      this.trigger(
        'itemSelected',
        {
          selectedItem: this.collection.get(item_id),
          collection: this.collection.models,
          currentQuery: searchValue,//this.options.query,
          matchedPath: path,          // ADD - pass the resolved path to Form.View
          isResultCompleted: this.options.ajaxDone,
        }
      );
      // var modelSearchPage = '/model-search/' + item_id;
      var modelSearchPage = '/model-search/' + path;
      
      Backbone.history.navigate(modelSearchPage, {
        trigger: true,
      });

    },

    setFocus: function setFocus() {
      this.$searchElement.focus();
    },

    selectFirstIfRequire: function selectFirstIfRequire() {
      if (this.options.highlightFirst) {
        var $menu_container = this.$searchElement.data('ttTypeahead').menu;
        var current_cursor_index = $menu_container
          .find('.tt-suggestion.tt-cursor')
          .index();

        if (current_cursor_index === -1) {
          $menu_container.find('.tt-suggestion').first().addClass('tt-cursor');
        }
      }
    },

    // the methd getSelectedItemDisplayText asking for the string of each item
    loadSuggestionItemsSource: function loadSuggestionItemsSource(
      query,
      callback,
      callbackAsync
    ) {
      var self = this;
      Tracker.getInstance().trackSearch(query);

      self.options.ajaxDone = false;
      self.options.results = {};
      self.options.query = PartLookupSearcherUtils.formatKeywords(query);
      self.options.lastTypedQuery = self.options.query;
      this.collection = new this.options.collection(
        [],
        this.options.collectionOptions
      );

      // if the character length from the query is over the min length
      if (self.options.query.length >= self.options.minLength) {
        self.options.labels = [`see-all-${self.options.query}`];
        callback(self.options.labels);
      }

      // silent = true makes it invisible to any listener that is waiting for the data to load
      // We can use jQuery's .done, as the fetch method returns a promise
      // http://api.jquery.com/deferred.done/
      self.collection
        .fetch({
          data: {
            q: String(self.options.query).trim(),
            // sort: self.options.sort,
            // limit: self.options.limit,
            // offset: 0,
          },
          killerId: _.uniqueId('ajax_killer_'),
        },
        {
          silent: true,
        })
        .done(function () {
          self.options.ajaxDone = true;
          self.options.labels = self.options.showSeeAll
            ? [`see-all-${self.options.query}`].concat(
                self.getItemIds(self.collection)
              )
            : self.getItemIds(self.collection);

          if (!self.options.labels.length) {
            self.options.labels = [`see-all-${self.options.query}`];
          }

          callbackAsync(self.options.labels);

          self.selectFirstIfRequire();
        });
    },

    // rather than Item.Model (let say Product.Model)
    getItemIds: function getItemIds(collection) {
      return collection.map(function (model) {
        return model.id;
      });
    },

    getSelectedItemDisplayText: function (item_id) {
      return this.getItemDisplayName(
        this.collection.get(item_id),
        this.options.query
      );
    },

    getItemDisplayName: function (item, query) {
      return _.isFunction(this.options.getItemDisplayName)
        ? this.options.getItemDisplayName(item, query)
        : item
        ? item.get('_name')
        : query;
    },

    getSuggestionItemTemplate: function (item_id) {
      var item_view_options = _.extend({}, this.options.itemViewOptions, {
        model: this.collection.get(item_id),
        query: this.options.query,
        areResults: !!this.collection.length,
        isAjaxDone: this.options.ajaxDone,
      });
      var items_searcher_item = new this.options.itemView(item_view_options);

      items_searcher_item.render();
      return items_searcher_item.$el;
    },

    onKeyUp: function (e) {
      // @event keyUp
      this.trigger(
        'keyUp',
        {
          collection: this.collection.models,
          eventObject: e,
          currentQuery: this.getCurrentQuery(),
        }
      );

    },

    onKeyDown: function (e) {
      var current_text = this.$searchElement.typeahead('val');
      if (
        this.options.selectedItem &&
        current_text !==
          this.getItemDisplayName(this.options.selectedItem, this.options.query)
      ) {
        this.options.selectedItem = null;

        this.trigger('itemSelected', {
          selectedItem: null,
          collection: this.collection.models,
          currentQuery: this.options.query,
        });
      }

      // @event keyDown
      this.trigger(
        'keyDown',
        {
          collection: this.collection.models,
          eventObject: e,
          currentQuery: this.getCurrentQuery(),
        }
      );
    },

    destroy: function () {
      SCView.call(this);

      console.log('destroy - searcher', destroy);
      // this.off('afterViewRender');
      this.options.application.getLayout().off('afterAppendView');

      this.$searchElement.off('click');
    },

    getContext: function () {
      return {
        placeholderLabel: this.options.placeholderLabel,
        maxLength: this.options.maxLength,
        showId: !!this.options.componentId,
        id: this.options.componentId,
        showName: !!this.options.componentName,
        name: this.options.componentName,
      };
    },

  });

  return PartLookupSearcherView
});
